import React from "react";
import { Lock } from "lucide-react";
import { Panel, Stat } from "./Panel";

const STATS = [["historical_mailcoach", "Historical Mailcoach subscribers", "slate"], ["verified_eligible", "Verified eligible", "emerald"],
  ["verified_explicit", "Verified explicit consent", "emerald"], ["verified_soft_opt_in", "Verified soft opt-in", "emerald"],
  ["pending_checkout_verification", "Checkout opt-ins awaiting wording check", "amber"], ["historical_subscribed_pending_evidence", "Mailcoach subscribed, evidence pending", "amber"],
  ["suppressed", "Suppressed", "red"], ["unsubscribed", "Unsubscribed", "red"], ["ambiguous", "Ambiguous (held)", "amber"]];

export const ReadinessSummary = ({ d }) => (
  <Panel testid="launch-summary" title={d.go ? "All launch checks passed — awaiting your approval" : "Not ready to launch"}
    sub="Historical subscribers keep their Mailcoach and WooCommerce evidence. Nobody becomes mailable until that evidence is verified; past deliveries are never treated as consent."
    right={<span className="inline-flex items-center gap-1 text-xs rounded-full px-2.5 py-1 bg-slate-900 text-white" data-testid="launch-lock">
      <Lock className="w-3 h-3" />{d.live_sending_locked ? "Live sending locked" : "Live sending approved"}</span>}>
    <div className="grid gap-2 grid-cols-2 sm:grid-cols-3 lg:grid-cols-5">
      {STATS.map(([k, l, t]) => <Stat key={k} label={l} value={d.subscribers[k]} tone={t} testid={`launch-stat-${k}`} />)}
      <Stat label="All subscriber records" value={d.subscribers.total} testid="launch-stat-total" />
    </div>
    {d.blockers.length > 0 && <div className="rounded-lg bg-amber-50 border border-amber-200 p-3" data-testid="launch-blockers">
      <p className="text-xs font-semibold text-amber-900 mb-1">Outstanding launch blockers</p>
      <ul className="list-disc pl-5 text-xs text-amber-900 space-y-0.5">{d.blockers.map((b) => <li key={b}>{b}</li>)}</ul></div>}
  </Panel>
);
